import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SurveyComponent } from "./survey.component";
import { IonicModule } from "@ionic/angular";
import { SurveyFieldModule } from "src/app/components/survey-field/survey-field.module";
import { DefaultValueModule } from "src/app/pipes/default-value/default-value.module";
import { GetSymbolModule } from "src/app/pipes/get-symbol/get-symbol.module";
import { TranslateModule } from "@ngx-translate/core";
import { IframeModalModule } from "src/app/modals/iframe-modal/iframe-modal.module";

@NgModule({
  declarations: [SurveyComponent],
  imports: [CommonModule, IonicModule, TranslateModule, SurveyFieldModule, GetSymbolModule, DefaultValueModule, IframeModalModule],
  exports: [SurveyComponent],
})
export class SurveyModule {}
